<template>
  <div>
    <fixed-label-filter label="活跃频率">
      <a-select v-model="selectedDay" style="width:120px" @change="changeDayType">
        <a-select-option value="all">全部</a-select-option>
        <a-select-option value="1">1天内</a-select-option>
        <a-select-option value="3">3天内</a-select-option>
        <a-select-option value="30">30天内</a-select-option>
        <a-select-option value="365">365天内</a-select-option>
      </a-select>
    </fixed-label-filter>
    <a-row :gutter="8" class="mt-2">
      <a-col>
        <area-chart v-if="data.areas" :data="data" />
      </a-col>
      <a-col>
        <version-chart v-if="data.versions" :data="data" />
      </a-col>
      <a-col>
        <arch-chart v-if="data.cpu_archs" :data="data" />
      </a-col>
      <a-col>
        <provider-chart v-if="data.providers" :data="data" />
      </a-col>
      <a-col>
        <other :data="data" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/grid'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/axisPointer'
import AreaChart from './charts/area'
import VersionChart from './charts/version'
import ArchChart from './charts/arch'
import ProviderChart from './charts/provider'
import Other from './charts/other'

export default {
  name: 'ChartList',
  components: {
    AreaChart,
    VersionChart,
    ArchChart,
    ProviderChart,
    Other,
  },
  props: {
    dayType: [String, Number],
    changeDayType: Function,
  },
  data () {
    return {
      data: {},
      selectedDay: '30',
    }
  },
  watch: {
    selectedDay () {
      this.fetchAnalysis()
    },
    dayType: {
      immediate: true,
      handler (val) {
        if (val) {
          this.selectedDay = val
        }
      },
    },
  },
  created () {
    this.$rM = new this.$Manager('opensource_reports/analysis', 'v2')
    this.fetchAnalysis()
  },
  activated () {
    this.selectedDay = this.dayType
  },
  methods: {
    fetchAnalysis () {
      const params = this.selectedDay === 'all' ? {} : { days: this.selectedDay }
      this.$rM.list({
        params,
      }).then(res => {
        this.data = res.data
      })
    },
  },
}
</script>
